var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "demo-box" },
    [
      _c("TopNavigation", { attrs: { "top-act": "7" } }),
      _vm.$store.state.webNavigator == "pc"
        ? _c("div", { staticClass: "content" }, [
            _vm._m(0),
            _vm._m(1),
            _c("div", { staticClass: "app-banner3" }, [
              _vm._m(2),
              _c("div", { staticClass: "app-banner3-tzcBar" }, [
                _c("div", { staticClass: "app-banner3-tzcLeft displayIB" }, [
                  _c(
                    "div",
                    { staticClass: "app-banner3-LeftTop" },
                    [
                      _c("p", { staticClass: "app-banner3-tltTwo font26px" }, [
                        _vm._v("4项深度脂肪测量")
                      ]),
                      _vm._l(_vm.banner3List, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "displayIB app-banner3-item"
                          },
                          [
                            _c("img", {
                              staticClass: "app-banner3-icon",
                              attrs: { title: "", src: item.imgUrl, alt: "" }
                            }),
                            _c(
                              "p",
                              { staticClass: "app-banner3-Name font17px" },
                              [_vm._v(_vm._s(item.name))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "app-banner3-LeftBottom" },
                    [
                      _c("p", { staticClass: "app-banner3-tltTwo font26px" }, [
                        _vm._v("6项身体数据评估")
                      ]),
                      _vm._l(_vm.banner3List2, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "displayIB app-banner3-item"
                          },
                          [
                            _c("img", {
                              staticClass: "app-banner3-icon",
                              attrs: { title: "", src: item.imgUrl, alt: "" }
                            }),
                            _c(
                              "p",
                              { staticClass: "app-banner3-Name font17px" },
                              [_vm._v(_vm._s(item.name))]
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "app-banner3-tzcRight displayIB" },
                  [
                    _c("p", { staticClass: "app-banner3-tltTwo font26px" }, [
                      _vm._v("14项重要身体数据")
                    ]),
                    _vm._l(_vm.banner3List3, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "displayIB app-banner3-item"
                        },
                        [
                          _c("img", {
                            staticClass: "app-banner3-icon",
                            attrs: { title: "", src: item.imgUrl, alt: "" }
                          }),
                          _c(
                            "p",
                            { staticClass: "app-banner3-Name font17px" },
                            [_vm._v(_vm._s(item.name))]
                          )
                        ]
                      )
                    })
                  ],
                  2
                )
              ])
            ]),
            _vm._m(3),
            _vm._m(4),
            _c("div", { staticClass: "app-banner6" }, [
              _c("p", { staticClass: "app-banner6-tlt font44px col33333" }, [
                _vm._v("合作市场")
              ]),
              _c(
                "div",
                { staticClass: "app-banner6-bar" },
                _vm._l(_vm.banner6List, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "displayIB app-banner6-tip" },
                    [
                      _c("img", {
                        staticClass: "app-banner6-img",
                        attrs: { title: "", src: item, alt: "" }
                      })
                    ]
                  )
                }),
                0
              )
            ])
          ])
        : _c("div", { staticClass: "phone-page" }, [
            _vm._m(5),
            _vm._m(6),
            _c("div", { staticClass: "phoneApp-banner3" }, [
              _vm._m(7),
              _c(
                "div",
                { staticClass: "banner3-ListBox" },
                _vm._l(_vm.phoneIconList, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "banner3-List" },
                    [
                      _c("div", { staticClass: "banner3-ListTlt" }, [
                        _vm._v(_vm._s(item.tlt))
                      ]),
                      _c(
                        "div",
                        { staticClass: "banner3-iconList" },
                        _vm._l(item.list, function(item2, index2) {
                          return _c(
                            "div",
                            {
                              key: index2,
                              staticClass: "banner3-icon displayIB positionRE"
                            },
                            [
                              _c("img", {
                                staticClass: "banner3-iconImg",
                                attrs: { title: "", src: item2.imgUrl, alt: "" }
                              }),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "banner3-iconP font15phone col666666 positionAB"
                                },
                                [_vm._v(_vm._s(item2.name))]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._m(8),
            _vm._m(9),
            _c("div", { staticClass: "phoneApp-banner6" }, [
              _vm._m(10),
              _c(
                "div",
                { staticClass: "banner5-ListBox" },
                _vm._l(_vm.banner5IconList, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "banner5-Icon displayIB" },
                    [
                      _c("img", {
                        staticClass: "banner5-IconImg",
                        attrs: { title: "", src: item, alt: "" }
                      })
                    ]
                  )
                }),
                0
              )
            ])
          ]),
      _c("FooterNavigation")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-banner1 positionRE" }, [
      _c("div", { staticClass: "app-banner1-bar" }, [
        _c("div", [
          _c("p", { staticClass: "app-banner1-tlt font44px" }, [
            _vm._v("脂玫乐APP -专业健康瘦身")
          ]),
          _c("p", { staticClass: "app-banner1-tip font26px" }, [
            _vm._v("瘦身有计划 轻松不反弹")
          ])
        ]),
        _c("div", [
          _c("div", { staticClass: "displayIB" }, [
            _c("div", { staticClass: "app-banner1-ewm" })
          ]),
          _c("div", { staticClass: "displayIB app-banner1-right" }, [
            _c("div", { staticClass: "app-banner1-bnt" }, [
              _c("div", { staticClass: "iosIcon displayIB" }),
              _vm._v("\n              App Store\n            ")
            ]),
            _c("div", { staticClass: "app-banner1-bnt" }, [
              _c("div", { staticClass: "AndroidIcon displayIB" }),
              _vm._v("\n              Android\n            ")
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-banner2 positionRE" }, [
      _c("div", { staticClass: "app-banner2-bar positionAB" }, [
        _c("p", { staticClass: "app-banner2-tlt font44px" }, [
          _vm._v("健康评测")
        ]),
        _c("p", { staticClass: "app-banner2-p font26px" }, [
          _vm._v("\n          根据用户的性别、身高、生日、 "),
          _c("br"),
          _vm._v("\n          体重、体重目标等数据，"),
          _c("br"),
          _vm._v("\n          提供每日所需热量、"),
          _c("br"),
          _vm._v("\n          目标体重建议以及健康评级。"),
          _c("br")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-banner3-bar" }, [
      _c("p", { staticClass: "app-banner3-tlt font44px" }, [_vm._v("体脂秤")]),
      _c("p", { staticClass: "app-banner3-p font26px" }, [
        _vm._v(
          "\n          为了帮助用户管理更多的身体数据，支持对接脂玫乐体脂秤设备。 "
        ),
        _c("br"),
        _vm._v("\n          全面检测身体24项健康数据\n        ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-banner4 positionRE" }, [
      _c("div", [
        _c("p", { staticClass: "app-banner4-tlt font44px col33333" }, [
          _vm._v("记录功能")
        ]),
        _c("p", { staticClass: "app-banner4-text font26px col666666" }, [
          _vm._v("身体数据记录、饮食记录、运动记录")
        ])
      ]),
      _c("div", { staticClass: "app-banner4-BgImg" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "app-banner5 positionRE" }, [
      _c("div", [
        _c("p", { staticClass: "app-banner5-tlt font44px col33333" }, [
          _vm._v("跟踪指导")
        ]),
        _c("p", { staticClass: "app-banner5-text font26px col666666" }, [
          _vm._v("\n          不止是简单的减肥健康工具 "),
          _c("br"),
          _vm._v(
            "\n          专业团队将针对个体提供量身定制个性化瘦身方案和全程跟踪指导。\n        "
          )
        ])
      ]),
      _c("div", { staticClass: "app-banner5-BgImg" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "phoneApp-banner positionRE" }, [
      _c("div", { staticClass: "banner-TextBox" }, [
        _c("p", { staticClass: "banner-tlt font46phone" }, [
          _vm._v("脂玫乐APP -专业健康瘦身")
        ]),
        _c("p", { staticClass: "banner-p font28phone" }, [
          _vm._v("瘦身有计划      轻松不反弹")
        ])
      ]),
      _c("div", { staticClass: "banner-ewmBox" }, [
        _c("div", { staticClass: "banner-ewm" }),
        _c("div", { staticClass: "banner-btnBox displayIB" }, [
          _c("div", { staticClass: "banner-btn" }, [
            _c("span", { staticClass: "banner-BtnIos" }),
            _vm._v(" App Store")
          ]),
          _c("div", { staticClass: "banner-btn" }, [
            _c("span", { staticClass: "banner-BtnAndroid" }),
            _vm._v(" Android")
          ])
        ])
      ]),
      _c("div", { staticClass: "banner-fotImg positionAB" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "phoneApp-banner2 positionRE" }, [
      _c("div", { staticClass: "banner2-TextBox" }, [
        _c("p", { staticClass: "banner2-tlt font46phone" }, [
          _vm._v("健康评测")
        ]),
        _c("p", { staticClass: "banner2-p font28phone col666666" }, [
          _vm._v("\n          根据用户的性别、身高、生日、体重、体重目 "),
          _c("br"),
          _vm._v("\n          标等数据，提供每日所需热量、 "),
          _c("br"),
          _vm._v("\n          目标体重建议以及健康评级。 "),
          _c("br")
        ])
      ]),
      _c("div", { staticClass: "banner2-img positionAB" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner3-textBox" }, [
      _c("p", { staticClass: "banner2-tlt font46phone" }, [_vm._v("体脂秤")]),
      _c("p", { staticClass: "banner2-p font28phone col666666" }, [
        _vm._v("\n          为了帮助用户管理更多的身体数据，支持对 "),
        _c("br"),
        _vm._v(
          "\n          接脂玫乐体脂秤设备，全面检测身体24项健康数据。\n        "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "phoneApp-banner4 positionRE" }, [
      _c("div", { staticClass: "banner4-textBox" }, [
        _c("p", { staticClass: "banner4-tlt font46phone" }, [
          _vm._v("记录功能")
        ]),
        _c("p", { staticClass: "banner2-p font28phone col666666" }, [
          _vm._v("\n          身体数据记录、饮食记录、运动记录\n        ")
        ])
      ]),
      _c("div", { staticClass: "banner4-img positionAB" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "phoneApp-banner5 positionRE" }, [
      _c("div", { staticClass: "banner5-textBox" }, [
        _c("p", { staticClass: "banner4-tlt font46phone" }, [
          _vm._v("跟踪指导")
        ]),
        _c("p", { staticClass: "banner2-p font28phone col666666" }, [
          _vm._v("\n          不止是简单的减肥健康工具， "),
          _c("br"),
          _vm._v("\n          专业团队将针对个体提供量身定制个性化瘦身方案 "),
          _c("br"),
          _vm._v("\n          和全程跟踪指导。 "),
          _c("br")
        ])
      ]),
      _c("div", { staticClass: "banner5-img positionAB" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner5-textBox" }, [
      _c("p", { staticClass: "banner4-tlt font46phone" }, [_vm._v("合作市场")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e2c7984", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e2c7984","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/zmlApp/zmlapp.vue
// module id = 1200
// module chunks = 15